import { SSE_URL } from "./constants.js";

let eventSource = null;
let autoReconnect = true;

// 从 localStorage 获取 SSE 状态
export function getSSEStatus() {
  const enabled = localStorage.getItem('sseEnabled');
  // 默认开启
  return enabled === null ? true : enabled === 'true';
}

// 设置 SSE 状态
export function setSSEStatus(enabled) {
  localStorage.setItem('sseEnabled', enabled);
  if (enabled) {
    autoReconnect = true;
    connectSSE();
  } else {
    autoReconnect = false;
    disconnectSSE();
  }
}

// 请求通知权限
async function requestNotificationPermission() {
  if (!("Notification" in window)) {
    console.log("该浏览器不支持通知功能");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  } catch (error) {
    console.error("请求通知权限失败:", error);
    return false;
  }
}

// 发送浏览器通知
function sendBrowserNotification(title, options = {}) {
  if (Notification.permission === "granted") {
    new Notification(title, options);
  }
}

// 处理不同类型的消息
function handleMessage(data) {
  switch (data.type) {
    case "notification":
      console.log("收到通知消息:", data.notification);
      sendBrowserNotification(data.notification.title, {
        body: data.notification.message,
        icon: `${process.env.PUBLIC_URL}/favicon.ico`,
      });
      break;

    case "keepalive":
      console.log("收到keepalive消息");
      break;

    default:
      console.log("收到未知类型消息:", data);
  }
}

export async function connectSSE() {
  // 如果 SSE 被禁用，直接返回
  if (!getSSEStatus()) {
    return null;
  }

  if (eventSource && eventSource.readyState === EventSource.OPEN) {
    return eventSource;
  }

  if (eventSource) {
    eventSource.close();
    eventSource = null;
  }

  // 请求通知权限，如果被拒绝，则不再请求
  if (await requestNotificationPermission() === false) {
    console.log("通知权限请求失败，可能已被拒绝。");
  }

  eventSource = new EventSource(SSE_URL, { withCredentials: true });

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      handleMessage(data);
    } catch (error) {
      console.error("SSE消息解析错误:", error);
    }
  };

  eventSource.onerror = (error) => {
    console.error("SSE连接错误:", error);
    eventSource.close();
    eventSource = null;

    // 只有在自动重连开启时才重连
    if (autoReconnect && getSSEStatus()) {
      setTimeout(() => {
        connectSSE();
      }, 5000);
    }
  };

  return eventSource;
}

export function disconnectSSE() {
  if (eventSource) {
    eventSource.close();
    eventSource = null;
  }
}